export {
  CollectionBuilder,
  createLeafComponent,
  createBranchComponent,
  type CollectionBuilderProps
} from '../src/collections/CollectionBuilder';
